import { Link } from '@tanstack/react-router';
import { cx } from '../ui/cx.js';
import { helpArticlePath, type TeamHelpSlug } from './paths.js';

/** Point d'interrogation cerclé (grille de 24, trait de 1,5 px, comme les icônes de `ui/icons`). */
export function HelpIcon({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      focusable="false"
      className={className}
    >
      <circle cx={12} cy={12} r={8.5} />
      <path d="M9.6 9.6a2.4 2.4 0 1 1 3.3 2.2c-.6.3-.9.8-.9 1.4v.4M12 16.3v.1" />
    </svg>
  );
}

/**
 * Lien contextuel « ? » d'un écran de l'espace garage vers l'article d'aide qui l'explique. Zone
 * tactile des jetons de densité (44 px au téléphone), nom accessible explicite. Léger : n'importe pas
 * le contenu de l'aide (chargé à la demande avec ses pages).
 */
export function HelpLink({ article, label, className }: { article: TeamHelpSlug; label: string; className?: string }) {
  return (
    <Link
      to={helpArticlePath('team', article)}
      aria-label={`Aide : ${label}`}
      title={`Aide : ${label}`}
      className={cx(
        'inline-grid min-h-(--ctl-sm) min-w-(--ctl-sm) shrink-0 place-items-center rounded-full text-ink-3 transition-colors hover:bg-sunken hover:text-ink focus-visible:outline-2 focus-visible:outline-focus',
        className,
      )}
    >
      <HelpIcon size={20} />
    </Link>
  );
}
